// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"fb6963a6","buttonRow":"e7c21cc4","saveButtonContainer":"c4fff272","saveButton":"d464f97f"};